import {useSelector} from 'react-redux';

import {BADGE_STATUSES} from '@/consts/loyalty/badgeStatuses';
import {getBadgeDetailsContent} from '@/services/content/appContent';
import {formatNotificationWithPlural} from '@/services/plural/pluralService';
import {selectLanguageCode} from '@/state/selectors/app';
import type {LevelBadgeDetailsContentModel} from '@/types/aem';
import type {Badge} from '@/types/loyalty';

function useBadgeNotification(badge: Badge, content: LevelBadgeDetailsContentModel | undefined) {
    const languageCode = useSelector(selectLanguageCode);
    const isEarned = badge.status === BADGE_STATUSES.COMPLETED;

    const {howToEarnBadgeInlineNotification, badgeEarnedInlineNotification, earnBadgePluralForms} = content ?? {};

    if (isEarned) return badgeEarnedInlineNotification;

    const remaining = Math.max(0, (badge.totalSteps ?? 0) - (badge.finishedSteps ?? 0));

    return formatNotificationWithPlural(howToEarnBadgeInlineNotification, remaining, earnBadgePluralForms, languageCode);
}

const useJourneyNotification = (badge: Badge) => {
    const {multiLevelBadgeDetailsContent} = getBadgeDetailsContent();
    return useBadgeNotification(badge, multiLevelBadgeDetailsContent);
};

export const useSingleLevelNotification = (badge: Badge) => {
    const {singleLevelBadgeDetailsContent} = getBadgeDetailsContent();
    return useBadgeNotification(badge, singleLevelBadgeDetailsContent);
};

export default useJourneyNotification;
